import Route from "vue-routisan";
import vuex from "@/vuex";
import isAuthenticated from "../middlewares/isAuthenticated";
import isAuditor from "../middlewares/isAuditor";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";
import userPermission from "@/util/valueObjects/userPermission";

Route.group({}, () => {
  Route.group({prefix: "logistic_manager",beforeEnter: [isAuthenticated,hasIntegraPermission]}, () => {
    Route.group({prefix: "auditor", beforeEnter: [isAuditor]}, () => {

      Route.redirect("/", to => {
        return {name: "auditor.dashboard"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/Dashboard/Dashboard.vue")
      ).name("auditor.dashboard");

      Route.group({prefix: "user"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/user/UserList")
        ).name("auditor.user");

        Route.view("/create", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/user/UserCreate")
        ).name("auditor.user_create");

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/user/UserUpdate")
        ).name("auditor.user_update");

      });

      Route.group({prefix: "purchase_order"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/purchaseOrder/PurchaseOrderList")
        ).name("auditor.purchase_order")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });

        Route.view("/create", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/purchaseOrder/PurchaseOrderCreate")
        ).name("auditor.purchase_order_create")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });

        Route.view("/exports", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/export/PrePurchaseOrderReport")
        ).name("auditor.purchase_order_exports")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });

        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/purchaseOrder/PurchaseOrderDetails")
        ).name("auditor.purchase_order_details")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });

        Route.view("/board", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/purchaseOrder/PurchaseOrderBoard")
        ).name("auditor.purchase_order_board")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });
      });

      Route.group({prefix: "order"}, () => {

        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/order/OrderDetails")
        ).name("auditor.order_details");

      });

      Route.group({prefix: "imports"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "auditor" */ "@/resources/views/logistic_manager/auditor/import/ReportImport")
        ).name("auditor.imports");
      });
    });
  });
});

export default Route.all();
